import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { DesiredFunction } from './desired-function.interface';
import { DesiredFunctionService } from './desired-function.service';

const service = new DesiredFunctionService();

export interface DesiredFunctionState {
   desiredFunctions: Array<DesiredFunction>;
}

const DesiredFunctionStore: Module<DesiredFunctionState, StoreState> = {
   namespaced: true,
   state: {
      desiredFunctions: [],
   },
   getters: {},
   mutations: {},
   actions: {
      async searchDesiredFunctions(context, query?: LocationQuery) {
         const response = await service.getDesiredFunction({ ...query, page: '1', per_page: '9999', include: 'category' });
         return response.data;
      },
   },
};

export default DesiredFunctionStore;
